import { render, staticRenderFns } from "./WithdrawFunds.vue?vue&type=template&id=4b1c0528&"
import script from "./WithdrawFunds.vue?vue&type=script&lang=js&"
export * from "./WithdrawFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports